module.exports = __webpack_public_path__ + "img/cw-logo.6ba17456.svg";